<template>
   <div class="create-class container-fluid course-width"> 
    <div class="margin-left-2Perc">
      <div class="row create-new-Panel-BG vertical-align">
        <div class="col-md-3 col-lg-3 margin-Top-Bottom-0-8Perc text-align-left">
          <button class="btn btn-primary btn-block create-course-button-BG black-font-color" v-show="false">{{firstButtonTitle}}</button>
          Create Master Course
        </div>
        <div class="col-md-3 col-lg-3 margin-Top-Bottom-0-5Perc">
          <button class="btn btn-primary btn-block participants-files-button-BG black-font-color" v-show="false">{{secondButtonTitle}}</button>
        </div>
        <div class="col-md-3 col-lg-3 margin-Top-Bottom-0-5Perc">
          <button class="btn btn-primary btn-block participants-files-button-BG black-font-color" v-show="false">{{thirdButtonTitle}}</button>
        </div>
        <div class="col-md-3 col-lg-3 text-align-right">
            <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc cursor-pointer float-right" alt="close-icon" v-on:click="updateClickedCreateCourseFlag($event)">
        </div>
      </div>
      <div class="row image-height vertical-align margin-Top-Bottom-2Point5Perc">
        <div class="col-md-6 col-lg-6 form-horizontal">
          <div class="form-group margin-bottom-21px">
            <label class="control-label col-sm-3" for="coursetitle">
              {{createCourseTitleLabel}}
            </label>
            <div class="col-sm-9">
              <input type="text" class="form-control" id="coursetitle" v-model="courseTitleValue" :maxLength="maxLength">
            </div>
          </div>
          <div class="form-group">
            <label class="control-label col-sm-3" for="coursesubtitle">
              {{createCourseSubTitleLabel}}
            </label>
            <div class="col-sm-9"> 
              <input type="text" class="form-control" id="coursesubtitle" v-model="courseSubTitleValue" :maxLength="subTitleMaxLength">
            </div>
          </div>
          <div class="form-group margin-bottom-21px">
            <label class="control-label col-sm-3" for="coursesubtitle">
              {{toolkitFileTextLabel}}
            </label>
            <div class="col-sm-9 padding-top-7px"> 
              <input type="file" id="toolkitfile" accept=".pdf">
            </div>
          </div>
          <div class="form-group">
            <label class="control-label col-sm-3" for="coursesubtitle">
              Course Type
            </label>
            <div class="col-sm-3"> 
              <select class="form-control" v-model="courseTypeValue">
                <option value=0>Normal</option>
                <option value=1>Mentora Moments</option>
              </select>
            </div>
            <label class="control-label col-sm-2" for="courseversion">
              Version
            </label>
            <div class="col-sm-4"> 
              <input type="text" class="form-control" id="courseversion" v-model="courseVersionValue">
            </div>
          </div>
          <div class="form-group">
            <label class="control-label col-sm-3" for="coursesubtitle">
              Lesson Numbering
            </label>
            <div class="col-sm-3" style="margin-top: 10px;"> 
              <select class="form-control" v-model="lessonNumberingValue">
                <option value=0>Default</option>
                <option value=1>Custom</option>
                <option value=2>Hide</option>
              </select>
            </div>
            <div class="col-sm-6" style="margin-top: 20px;"> 
              <div class="cursor-pointer" @click="openCourseDescOverlay($event, true)">+Add Course Description</div>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-lg-2 img-thumbnail choose-course-image-height course-image-box-border margin-bottom-15px padding-top-0Perc">
          <div class="row">
            <div class="col-md-12 col-lg-12 padding-left-right-0px" v-show="isCourseImageSelected">
              <div class="container padding-left-right-0px choose-course-image-height img-responsive">
                <img id="myimage" class="img-thumbnail choose-course-image-height img-responsive horizontal-center-align">
                <div class="middle cursor-pointer">
                 <div class="text" v-on:click="updateIsCourseImageSelectedFlag($event,false)">Remove</div>
                </div>
              </div>
            </div>  
            <div class="col-md-12 col-lg-12 padding-top-27Point5Perc" v-show="!isCourseImageSelected">
              <img src= "../assets/images/upload.svg" v-on:click="openFileExplorerWindow"  class="cursor-pointer img-responsive upload-img-width-height horizontal-center-align" alt="IPL-Logo">
              <div class="font-weight-bold cursor-pointer" v-on:click="openFileExplorerWindow">
              Choose Course Image
              </div>
            </div>  
          </div>  
          <div class="row">
            <div class="col-md-12 col-lg-12">
               <!-- <input type="file" id="courseimage" accept=".jpg, .jpeg, .png"> -->
               <input type="file" id="selectedFile" accept=".jpg, .jpeg, .png" style="display: none;" v-on:change="onFileSelected($event)"/>
            </div>  
          </div>
        </div>
        <div class="col-md-2 col-lg-2">
          <!-- ToDo: Track this -->
          <button class="btn btn-primary btn-block create-course-button-BG black-font-color" @click="createCourse">{{buildCourseButtonTitle}}</button>
        </div>  
        <div class="col-md-2 col-lg-2">
        </div>  
      </div>  
    </div>
    <add-rtf-course-description-overlay v-if="openDescriptionOverlay" @closeRtfEditorOverlay="closeRTFEditor" :addedDescription="courseObj.Description"></add-rtf-course-description-overlay>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  </div> 
</template>

<script>
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import AddRTFCourseDescriptionOverlay from '@/components/AddRTFCourseDescriptionOverlay'
import { courseService } from '@/server-util/course-service'
export default {
  name: 'create-class',
  data: function () {
    return {
      firstButtonTitle: 'Create Course',
      secondButtonTitle: 'Participants',
      thirdButtonTitle: 'Files',
      buildCourseButtonTitle: 'Build Course',
      createCourseTitleLabel: 'Title',
      createCourseSubTitleLabel: 'Sub-Title',
      courseImageTextLabel: 'Course Image',
      toolkitFileTextLabel: 'Toolkit File',
      isCourseImageSelected: false,
      clickedCreateCourse: false,
      showAlertDialog: false,
      isCourseCreated: false,
      obj: null,
      errorMsg: '',
      courseObj: {
        CourseTitle: '',
        SubTitle: '',
        IsEnabled: true,
        Type: 0,
        Version: '',
        LessonNumbering: 2,
        Description: null
      },
      maxLength: constants.Course_Title_Max_Length,
      subTitleMaxLength: constants.Course_Sub_Title_Max_Length,
      openDescriptionOverlay: false
    }
  },
  methods: {
    closeRTFEditor (value) {
      this.openDescriptionOverlay = value.closeRtfEditorOverlay
      this.courseObj.Description = value.description
      this.$store.state.isOverlayVisible = value.closeRtfEditorOverlay
    },
    openCourseDescOverlay: function (event, flagToUpdate = false) {
      this.openDescriptionOverlay = flagToUpdate
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    openFileExplorerWindow: function () {
      document.getElementById('selectedFile').click()
    },
    onFileSelected: function (event) {
      if (
        !this.checkCourseImageExtension(
          document.getElementById('selectedFile').value
        )
      ) {
        this.showAlertDialog = true
        this.errorMsg =
          'Please select .jpg, .jpeg or .png file.'
        event.target.value = ''
        this.updateIsCourseImageSelectedFlag(event, false)
        return
      }
      this.isCourseImageSelected = true
      var selectedFile = event.target.files[0]
      var reader = new FileReader()
      var imgtag = document.getElementById('myimage')
      imgtag.title = selectedFile.name
      reader.onload = function (event) {
        imgtag.src = event.target.result
      }
      reader.readAsDataURL(selectedFile)
    },
    updateIsCourseImageSelectedFlag: function (event, flagToUpdate) {
      this.isCourseImageSelected = flagToUpdate
    },
    updateClickedCreateCourseFlag: function (event) {
      // ToDo: Track this
      this.$emit('clickedCreateCourse', this.clickedCreateCourse)
    },
    checkCourseImageExtension: function (fileName) {
      var exts = ['.jpg', '.jpeg', '.png']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    chekcToolkitFileExtesion: function (fileName) {
      var exts = ['.pdf']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    createCourse: function (event) {
      if (this.validateRequiredFieldBeforeSubmit()) {
        var courseImg = document.getElementById('selectedFile').files[0]
        var toolkitFile = document.getElementById('toolkitfile').files[0]
        if (courseImg === undefined) {
          courseImg = null
        }
        const formData = new FormData()
        formData.append('CourseTitle', this.courseObj.CourseTitle)
        formData.append('SubTitle', this.courseObj.SubTitle)
        formData.append('IsEnabled', this.courseObj.IsEnabled)
        formData.append('CourseImage', courseImg)
        formData.append('ToolkitFile', toolkitFile)
        formData.append('Type', this.courseObj.Type)
        formData.append('Version', this.courseObj.Version)
        formData.append('LessonNumbering', this.courseObj.LessonNumbering)
        formData.append('Description', this.courseObj.Description)
        var _this = this
        var storeObj = this.$store
        if (formData !== undefined || formData !== '' || formData !== undefined) {
          // AK: Start showing spinner (Course file)
          _this.$emit('showSpinner', true)
          courseService
            .createCourseMaster(storeObj.state.access_token, formData)
            .then(
              responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  _this.$emit('showSpinner', false)
                  this.showAlertDialog = true
                  this.errorMsg =
                    '\'' +
                    this.courseObj.CourseTitle +
                    '\' Master Course created successfully.'
                  this.resetCourseObj()
                  // AK: Store given course object in our local db
                  storeObj.state.course_list.push(responseObj.data)
                  this.isCourseCreated = true
                  this.obj = responseObj.data
                } else {
                  // AK: Hide Spinner
                  _this.$emit('showSpinner', false)
                  this.showAlertDialog = true
                  this.errorMsg =
                    'Oops! Something went wrong. Please try again.'
                }
              },
              errorObj => {
                // AK: Hide Spinner
                _this.$emit('showSpinner', false)
                this.showAlertDialog = true
                if (errorObj.response === undefined) {
                  this.errorMsg = constants.No_Internet_Connection_Msg
                } else {
                  this.errorMsg = errorObj.response.statusText
                }
              }
            )
        } else {
          console.log(
            'Selected FormData is NULL hence declined CREATE COURSE OPERATION'
          )
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      if (this.isCourseCreated) {
        // AK: In order to show add lesson option immediately after creating course
        var obj = {
          isCourseCreated: true,
          newCreatedCourseObj: this.obj
        }
        this.$emit('newCreatedCourseObj', obj)
      }
    },
    resetCourseObj: function () {
      this.courseObj.CourseTitle = ''
      this.courseObj.SubTitle = ''
      this.courseObj.Version = ''
      this.isCourseImageSelected = false
      document.getElementById('selectedFile').value = ''
      document.getElementById('toolkitfile').value = ''
      this.courseObj.Type = 0
      this.courseObj.LessonNumbering = 0
      this.courseObj.Description = null
    },
    validateRequiredFieldBeforeSubmit: function () {
      var toolkitFile = document.getElementById('toolkitfile').files[0]
      if (this.courseObj.CourseTitle.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Title can\'t be empty.'
        return false
      }
      if (this.courseObj.SubTitle.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Subtitle can\'t be empty.'
        return false
      }
  /*  if (
        toolkitFile === null ||
        toolkitFile === undefined ||
        toolkitFile === 'undefined'
      ) {
        this.showAlertDialog = true
        this.errorMsg = 'No toolkit file selected.'
        return false
      } */
      console.log('toolkit :', toolkitFile)
      if (toolkitFile !== undefined && toolkitFile !== 'undefined' && toolkitFile !== null &&
        !this.chekcToolkitFileExtesion(
          document.getElementById('toolkitfile').value
        )
      ) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a .pdf file.'
        return false
      }
      return true
    }
  },
  components: {
    'alert-box': AlertBox,
    'add-rtf-course-description-overlay': AddRTFCourseDescriptionOverlay
  },
  computed: {
    courseTitleValue: {
      get: function () {
        return this.courseObj.CourseTitle
      },
      set: function (newValue) {
        this.courseObj.CourseTitle = newValue
      }
    },
    courseTypeValue: {
      get: function () {
        return this.courseObj.Type
      },
      set: function (newValue) {
        this.courseObj.Type = newValue
      }
    },
    lessonNumberingValue: {
      get: function () {
        return this.courseObj.LessonNumbering
      },
      set: function (newValue) {
        this.courseObj.LessonNumbering = newValue
      }
    },
    courseSubTitleValue: {
      get: function () {
        return this.courseObj.SubTitle
      },
      set: function (newValue) {
        this.courseObj.SubTitle = newValue
      }
    },
    courseIsEnabledValue: {
      get: function () {
        return this.courseObj.IsEnabled
      },
      set: function (newValue) {
        this.courseObj.IsEnabled = newValue
      }
    },
    courseVersionValue: {
      get: function () {
        return this.courseObj.Version
      },
      set: function (newValue) {
        this.courseObj.Version = newValue
      }
    }
  }
}
</script>

<style scoped>
.text-align-right {
  text-align: right !important;
}
.text-align-left {
  text-align: left !important;
}
.width {
  width: 100% !important;
}
.image {
  opacity: 1;
  display: block;
  width: 100%;
  height: auto;
  transition: 0.5s ease;
  backface-visibility: hidden;
}

.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}

.container:hover .image {
  opacity: 0.3;
}

.container:hover .middle {
  opacity: 1;
}

.text {
  background-color: black;
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  opacity: 0.6;
}
.cursor-pointer {
  cursor: pointer;
}
.course-width {
  width: 97.5%;
}
.upload-img-width-height {
  height: 40px;
  width: 40px;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.horizontal-center-align {
  margin: 0 auto;
}
.image-height {
  height: 250px !important;
}
.course-image-height {
  height: 138px !important;
}
.choose-course-image-height {
  height: 186px !important;
}
.course-image-box-border {
  border: 1px solid #dddddd;
}
.background-color-red {
  background-color: red;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.margin-left-Right-2Perc {
  margin-left: 4%;
  margin-right: 4%;
}
.create-new-Panel-BG {
  background-color: #dddddd;
}
.margin-Top-Bottom-0-8Perc {
  margin-top: 0.8%;
  margin-bottom: 0.8%;
}
.margin-Top-Bottom-2Perc {
  margin-top: 2%;
  margin-bottom: 2%;
}
.margin-Top-Bottom-2Point5Perc {
  margin-top: 2.5%;
  margin-bottom: 2.5%;
}
.create-course-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.participants-files-button-BG {
  background-color: #bbb !important;
  border: 1px solid #bbb !important;
}
.black-font-color {
  color: #000;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.border-color-green {
  border: 1px solid green;
}
.border-color-black {
  border: 1px solid black;
}
.padding-top-0Perc {
  padding-top: 0%;
}
.padding-top-13Perc {
  padding-top: 13%;
}
.font-weight-bold {
  font-weight: bold;
}
.padding-left-right-0px {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.close-img-width-height {
  width: 7%;
  height: 7%;
}
.float-right {
  float: right;
}
.border-red{
  border: 1px solid red !important;
}
.border-yellow{
  border: 1px solid yellow !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.padding-top-7px {
  padding-top:7px;
}
.margin-bottom-15px {
  margin-bottom:15px;
}
.padding-top-27Point5Perc {
  padding-top:27.5%;
}
.margin-bottom-7px {
  margin-bottom: 7px;
}
.margin-bottom-21px {
  margin-bottom:21px;
}
</style>


// WEBPACK FOOTER //
// src/components/CreateCourse.vue